import { Popover as BasePopover } from "antd"
import { ComponentProps } from "react"

export function Popover(props: ComponentProps<typeof BasePopover>) {
    return <BasePopover {...props} />
}
